import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { UserAvatar } from "./user-avatar.js";
import { TextRevealer } from "./text-revealer.js";

UserAvatar.Register();
TextRevealer.Register();

/**
* Get the proper edit / message buttons for a potluck item, depending on admin status etc
* @param itemEntity an nPotluckCategoryItem
* */
function GetActionButtons(itemEntity) {
    return html`
        <a class="button button-rectangle button-outline message-button" href="/trains/${window.CurrentTrain.Id}/message/${itemEntity.AssignedTo.Id}">
            <svg role="img" width="24" height="24" aria-label="Message"><use xlink:href="#envelope-blue" /></svg><span class="text">Message</span>
        </a>
        <a class="button button-rectangle button-blue edit-own-button" href="/potlucks/${window.CurrentTrain.Id}/volunteer/${itemEntity.Id}">
            <svg role="img" width="24" height="24" aria-label="Edit"><use xlink:href="#edit-white" /></svg><span class="text">Edit</span>
        </a>
        <a class="button button-rectangle button-outline edit-button" href="/potlucks/${window.CurrentTrain.Id}/volunteer/${itemEntity.Id}">
            <svg role="img" width="24" height="24" aria-label="Edit"><use xlink:href="#edit-blue" /></svg><span class="text">Edit</span>
        </a>`;
}

/**
 * Display an available or assigned meal train date, with action buttons
 * Expects potluckItem to be a nAccessibleEntity<nPotluckCategoryItem>
 */
export class PotluckRow extends UnshadowedElement {
    static elementName() { return "potluck-row" }

    static properties = {
        potluckItem: { type: Object },
    };

    render() {
        let rowContent;
        let actionContent;

        // May have an AssignedTo object with everything set to null, so check Id
        if (this.potluckItem.Entity.AssignedTo && this.potluckItem.Entity.AssignedTo.Id) {
            // Note: for non-meals (Plus) there is no description, so the notes get promoted to the description area
            rowContent = html`
                <div class="calendar-list-row__content-inner">
                    <div class="calendar-list-row__header-row">
                        <user-avatar avatar=${this.potluckItem.Entity.AssignedTo.Avatar} initials=${this.potluckItem.Entity.AssignedTo.Initials}></user-avatar>
                        <div>
                            <p class="calendar-list-row__name">${this.potluckItem.Entity.AssignedTo.FullName}</p>
                            <p class="calendar-list-row__description">
                                <text-revealer cutoff="80" text="${this.potluckItem.Entity.Description}"></text-revealer>
                            </p>
                        </div>
                    </div>
                    ${this.potluckItem.Entity.Notes ? html`<p class="calendar-list-row__notes"><text-revealer cutoff="120" text="${this.potluckItem.Entity.Notes}"></text-revealer></p>` : null}
                </div>
            `;
            actionContent = GetActionButtons(this.potluckItem.Entity);
        } else {
            // Unclaimed items
            rowContent = html`<p class="font:label-s">Available</p>`;
            actionContent = html`<a class="button button-rectangle button-teal volunteer-button" href="/potlucks/${window.CurrentTrain.Id}/volunteer/${this.potluckItem.Entity.Id}">Volunteer</a>`;
        }

        return html`
            <div class="calendar-list-row"
                ?data-is-booked=${this.potluckItem.Entity.AssignedTo && this.potluckItem.Entity.AssignedTo.Id}
                ?data-can-edit-booking=${this.potluckItem.CanAdminister || window.CurrentTrain.IsAdmin}
                ?data-is-own-booking=${this.potluckItem.Entity.AssignedTo && this.potluckItem.Entity.AssignedTo.Id === window.UserHash}>
                <div class="calendar-list-row__content-wrapper">
                    <div class="calendar-list-row__content">
                        ${rowContent}
                    </div>
                    <div class="calendar-list-row__actions">
                        ${actionContent}
                    </div>
                </div>
            </div>
        `;
    }
}
